<template>
    <section class="container relative">
        <div class="flex items-center justify-between">
            <AtomTitle> {{ title }} </AtomTitle>
            <div class="hidden gap-3 md:flex">
                <ArrowButton
                    id="news-prev"
                    aria-label="Предыдущая новость"
                    class="rotate-180" />
                <ArrowButton
                    id="news-next"
                    aria-label="Следующая новость" />
            </div>
        </div>

        <div class="mt-5 block max-w-full">
            <div class="swiper swiper-news">
                <div class="swiper-wrapper">
                    <div
                        v-for="item in items"
                        :key="item.slug || item.object + item.id"
                        class="swiper-slide !h-auto max-md:!w-[17.5rem]">
                        <NewsCard
                            :item
                            :hide-date
                            :card-type="getTypeOfCard(item.type_id)" />
                    </div>
                    <div class="swiper-slide !h-auto max-md:!w-[17.5rem]">
                        <SpecialCard :special-type="cardType" />
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="!hideNewsButton"
            class="mt-10 text-center md:mt-20">
            <BaseLink
                to="/news"
                target="_blank"
                icon-right="arrow-right"
                size="accent">
                Перейти к новостям
            </BaseLink>
        </div>
    </section>
</template>

<script setup lang="ts">
import { Swiper } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import { Navigation } from 'swiper/modules'

import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import ArrowButton from '~/components/base/arrow-button/ArrowButton.vue'
import BaseLink from '~/components/base/base-link/BaseLink.vue'
import SpecialCard from '~/components/particles/special-card/SpecialCard.vue'

import NewsCard from './NewsCard.vue'
import type { IArticleItem, INewsItem } from './news-section.types'

defineProps({
    items: {
        type: Array as PropType<INewsItem[] | IArticleItem[]>,
        required: true,
    },
    title: {
        type: String as PropType<string>,
        default: 'Читайте наши новости',
    },
    cardType: {
        type: String as PropType<'news' | 'article'>,
        default: 'news',
    },
    hideNewsButton: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    hideDate: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
})
function getTypeOfCard(type: number) {
    if (type == 1) return 'news'
    if (type == 2) return 'article'

    return 'news'
}

onMounted(() => {
    new Swiper('.swiper-news', {
        modules: [Navigation],
        navigation: {
            prevEl: '#news-prev',
            nextEl: '#news-next',
        },
        slidesPerView: 'auto',
        spaceBetween: 8,
        breakpoints: {
            375: {
                slidesPerView: 'auto',
                spaceBetween: 20,
            },
            744: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
    })
})

// const organization = getSeoOrganization()
// useSchemaOrg([
//     defineItemList({
//         numberOfItems: props.items.length,
//         itemListElement: props.items.map((item) => {
//             const mainImage = item.image ? item.image[0] : null
//             return defineListItem({
//                 item: defineArticle({
//                     '@type': 'NewsArticle',
//                     datePublished: item.published_at,
//                     headline: item.name,
//                     description: item.description,
//                     ...(mainImage && {
//                         image: defineSeoImage(mainImage),
//                     }),
//                     author: defineOrganization(organization),
//                 }),
//             })
//         }),
//     }),
// ])
</script>
